<div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

        <div class="min-height">
            <div class="col-md-12">
                <div class="header main-backgroundcolor color margin-b">
                    <div>Search Keyword</div>
                </div>

                <div class="form-group">
                    <input class="form-control" formControlName="search" type="search" placeholder="Keyword">
                </div>
            </div>

            <div class="col-md-12">
                <div class="header main-backgroundcolor color margin-b">
                    <div>Filter By Faith/Denomination</div>
                </div>

                <div class="form-group">

                    <input type="text" [value]="faithName" class="form-control" placeholder="Faith/Denomination"
                        (click)="open(mymodal,'faith')">

                </div>
            </div>
            <div class="col-md-12">
                <div class="header main-backgroundcolor color margin-b">
                    <div>Filter By Location</div>
                </div>

                <div class="form-group">
                    <!-- <app-app-auto (setAddress)="AddressChange($event)" title="Name your location"></app-app-auto> -->
                    <input type="text" [disabled]="show" class="form-control cursor" [value]="event"
                        placeholder="Location" (click)="shows()">


                </div>

                <div *ngIf="show" class="margin-b">

                    <div *ngIf="!loadershow" class="display" style="justify-content: center;">
                        <div class="loader"></div>
                    </div>
                    <div *ngIf="loadershow">

                        <app-shared-address [LatLng]="defaultBounds" (setAddress)="getAddress($event)">
                        </app-shared-address>

                        <!-- <app-app-auto (setAddress)="AddressChange($event)" [strictBounds]="boundsLimit"
                        [LatLng]="defaultBounds" title="Name your location"></app-app-auto>

                    <input type="checkbox" checked (change)="limitCheckbox()">Checkbox
                    <button class="btn btn-sm btn-primary" (click)="show = false">
                        add
                    </button> -->
                    </div>
                </div>



                <div *ngIf="!show">
                    <div class="form-group">
                        <input class="form-control" formControlName="city" type="text" placeholder="City">
                    </div>
                    <div class="form-group">
                        <input class="form-control" type="text" formControlName="state" placeholder="State">
                    </div>

                    <div class="form-group">
                        <input type="text" class="form-control" formControlName="areaCode" placeholder="Post Code">
                    </div>

                    <div class="form-group">
                        <input class="form-control" type="text" formControlName="country" placeholder="Country">
                    </div>
                </div>
            </div>
        </div>
        <br>
        <br>
        <div class="col-md-12">

            <button type='submit' [disabled]="show" (click)="onSubmit()"
                class="btn btn-block main-backgroundcolor color">Save</button>
        </div>
    </form>
</div>










<ng-template #mymodal let-modal>
    <div class="modal-header main-backgroundcolor">
        <h4 class="modal-title color" id="modal-basic-title">{{Title | titlecase}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="color">&times;</span>
        </button>
    </div>
    <div class="modal-body" *ngIf="Title  == 'faith'">

        <div *ngIf="loading == false">
            <app-card-skelton *ngFor="let props of arr"></app-card-skelton>
        </div>

        <div *ngIf="loading">
            <div class="card margin-b" *ngFor="let props of loadMoreArr; let i = index">
                <div class="card-body border-r">
                    <div class="display">
                        <div class="image-wrapper">
                            <img [src]="props.photo" (error)="getErrorImage($event)">
                        </div>
                        <div class="text-area display justify-content">
                            <div>
                                <h5 class="card-title">{{props.name}}</h5>
                                <p>{{props.description}}</p>
                            </div>
                            <div class="form-check-input-inner">
                                <input type="checkbox" [value]="props._id" (change)="selectItem($event,props)"
                                    class="form-check-input" id="exampleCheck1">
                            </div>
                        </div>

                    </div>



                </div>
            </div>

            <h6 *ngIf="showError" class="error">{{modalError}}</h6>

            <div *ngIf="showButton" style="text-align:center">
                <button type="button" class="btn color main-backgroundcolor btn-sm pull-right" (click)="showMore()">
                    Show more</button>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button *ngIf="!staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
            (click)="modal.close('Save click')">
            Select</button>




    </div>
</ng-template>